class FooterOvo extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.initAccordionAccessibility();
  }

  initAccordionAccessibility() {
    const headers = this.querySelectorAll('.footer-ovo__menu-accordion-header');
    const panels = this.querySelectorAll('.footer-ovo__menu-accordion-content');
    const radios = this.querySelectorAll('.footer-ovo__menu-accordion-radio');

    // Ensure proper aria attributes
    headers.forEach((header, i) => {
      const panel = panels[i];
      if (!panel || !radios[i]) return;

      // Update aria-selected when toggled
      radios[i].addEventListener('change', () => {
        // Smooth expand/collapse
        panels.forEach((p) => (p.style.maxHeight = null));
        if (radios[i].checked) {
          panel.style.maxHeight = panel.scrollHeight + 'px';
        }
      });

      if (i == 0) header.click();

      // Keyboard navigation
      header.addEventListener('keydown', (e) => {
        const key = e.key;
        const index = Array.from(headers).indexOf(header);
        let newIndex;

        switch (key) {
          case 'ArrowUp':
          case 'ArrowLeft':
            e.preventDefault();
            newIndex = (index - 1 + headers.length) % headers.length;
            headers[newIndex].focus();
            break;
          case 'ArrowDown':
          case 'ArrowRight':
            e.preventDefault();
            newIndex = (index + 1) % headers.length;
            headers[newIndex].focus();
            break;
          case 'Home':
            e.preventDefault();
            headers[0].focus();
            break;
          case 'End':
            e.preventDefault();
            headers[headers.length - 1].focus();
            break;
          case ' ':
          case 'Enter':
            e.preventDefault();
            radios[i].checked = true;
            radios[i].dispatchEvent(new Event('change', { bubbles: true }));
            break;
        }
      });
    });
  }
}

customElements.define('footer-ovo', FooterOvo);
